import { render, staticRenderFns } from "./ModelBrowser.vue?vue&type=template&id=652a6d2c&"
import script from "./ModelBrowser.vue?vue&type=script&lang=ts&"
export * from "./ModelBrowser.vue?vue&type=script&lang=ts&"
import style0 from "./ModelBrowser.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports